import { AddonProductsRequest } from "../interfaces/product.interface";
import { API_ENDPOINTS } from "./api-endpoints";
import { HttpClient } from "./http-client";
import { ERROR_MESSAGES } from "../utils/constants";

export const productDetailsClient = {

    getProductDetailsList: async (data: any) => {
        try {
            return await HttpClient.post(API_ENDPOINTS.QUOTE_BY_ID, data);
        } catch (firstError) {
            try {
                return await HttpClient.post(API_ENDPOINTS.QUOTE_BY_ID, data);
            } catch (secondError) {
                throw new Error(ERROR_MESSAGES.GENERIC_RETRY);
            }
        }
    },
    getProductDetails: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.PROUCT_BY_UUID, data);
    },
    createQuote: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.CREATE_QUOTE, data);
    },
    updateProduct: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.UPDATE_PRODUCT_QUOTE, data);
    },
    deleteCustomerQuoteProduct: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.DELETE_PRODUCT_QUOTE, data)
    },
    addCustomerQuoteProduct: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.ADD_PRODUCT_QUOTE, data)
    },
    placeOrder: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.PLACE_ORDER, data)
    },
    getBookingDate: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.BOOKING_DATE, data)
    },
    getProductDayRatePricing: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.GET_PRODUCT_PRICING_DAY, data)
    },
    getQuotesCharges: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.QUATE_CHARGES, data);
    },
    getQuoteCharges: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.GET_QUATE_CHARGES, data)
    },
    getProductPricing: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.GET_PRODUCT_PRICING, data)
    },
    updateCustomerQuote: (data: any, token?: string) => {
        return HttpClient.post(API_ENDPOINTS.UPDATE_CUSTOMER_QUOTE, data, token ? { _urlToken: token } : undefined);
    },
    getTermsConditions: (data: any, token?: string) => {
        return HttpClient.post(API_ENDPOINTS.GET_TERMS_CONDITIONS_INFO, data, token ? { _urlToken: token } : undefined);
    },
    deleteQuote: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.DELETE_QUATE, data);
    },
    getProductVariant: (data: any) => {
        return HttpClient.post(API_ENDPOINTS.GET_PRODUCT_VARIANT, data);
    },
    getAddonProducts: (data: AddonProductsRequest) => {
        return HttpClient.post(API_ENDPOINTS.GET_ADDON_PRODUCTS, data);
    },
    applyPromoCode: (data: any, token?: string) => {
        return HttpClient.post(API_ENDPOINTS.APPLY_PROMOCODE, data, token ? { _urlToken: token } : undefined);
    },
    removePromoCode: (data: any, token?: string) => {
        return HttpClient.post(API_ENDPOINTS.REMOVE_PROMOCODE, data, token ? { _urlToken: token } : undefined);
    }
}
